import React, { useRef, useEffect } from "react";
import ScrollTriggerSimple from "../helpers/scrollTriggerSimple";

function Homepage() {
  const buttonclassName = "text-xs mt-16 bg-transparent hover:bg-[#141833] text-[#141833] sm:text-[16px] sm:leading-[25px] xl:text-[16px] xl:leading-[26px] font-gothMed hover:text-white py-3 px-8 border border-[#707070] hover:border-transparent rounded";

  const bodyCopyclassName = "xs:text-center sm:text-left xs:px-5 xs:py-10 sm:px-10 md:pl-36 lg:pl-36 xl:pl-60 sm:py-20 lg:py-28 xs:text-[22px] xs:leading-[30px] sm:text-[30px] sm:leading-[48px] xl:text-[2rem] xl:leading-[45px] font-ppNeue";

  const homePageScroll = useRef();
  const { ref: homePageTitle1 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: homePageCopy1 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: homePageButton1 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: homePageImg1 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: homePageCopy2 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: homePageButton2 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: homePageTitle2 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: homePageImg2 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: homePageCopy3 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: homePageButton3 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");
  const { ref: homePageImg3 } = ScrollTriggerSimple(50, 0, "-50% 70%", "bottom 70%");

  useEffect(() => {});

  return (
    <>
      <section className="overflow-hidden" ref={homePageScroll}>
        <article className="xs:py-20 xs:px-5 sm:py-36 md:py-28 lg:py-50 bg-[#141833] flex">
          <p ref={homePageTitle1} className="content-center m-auto xs:text-2xl sm:text-3xl md:text-3xl text-[#EDB6A2] md:w-[700px] lg:text-3xl lg:!leading-[3rem] lg:w-[800px] xl:text-3xl xl:!leading-[3rem] xl:w-[1000px] sm:px-4 xl:px-12 font-ppNeue">
            We’re a design-led residential property development company creating fine, statement homes in North London and the Home Counties{" "}
          </p>
        </article>
        <article className={bodyCopyclassName}>
          <p ref={homePageCopy1}>
            Statement residences<br className="xs:hidden md:block"></br> that exceed expectations
          </p>
          <a href="/properties" rel="none">
            <button ref={homePageButton1} className={buttonclassName}>
              SEE PROPERTIES
            </button>
          </a>
        </article>
        <article className="text-right">
          <img ref={homePageImg1} className="inline-block" alt="" src="../images/homepage1.jpg"></img>
        </article>
        <article className={bodyCopyclassName}>
          <p ref={homePageCopy2}>
            A new era luxury home developer raising
            <br className="xs:hidden md:block"></br> the bar in terms of location, quality,
            <br className="xs:hidden md:block"></br> innovation and desirability
          </p>
          <a href="/about" rel="none">
            <button ref={homePageButton2} className={buttonclassName}>
              OUR STORY
            </button>
          </a>
        </article>
        <article className="content-center text-center m-auto xs:text-3xl xs:px-5 sm:text-4xl md:w-[700px] lg:text-4xl lg:!leading-[3rem] lg:w-[800px] xl:text-4xl xl:!leading-[4rem] xl:w-[1200px] px-12 py-24 font-ppNeue">
          <p ref={homePageTitle2}>Perfection is in our DNA</p>
        </article>
        <article className="text-left">
          <img ref={homePageImg2} className="inline-block" alt="" src="../images/homepage2.jpg"></img>
        </article>
        <article className={bodyCopyclassName}>
          <p ref={homePageCopy3}>
            Turning the mundane and practical
            <br className="xs:hidden md:block"></br> into magnificent and peerless
          </p>
          <a href="/design" rel="none">
            <button ref={homePageButton3} className={buttonclassName}>
              DESIGN
            </button>
          </a>
        </article>
        <article className="text-left">
          <div ref={homePageImg3} style={{ backgroundImage: `url("../images/homepageFooter.webp")` }} alt="hero" className="bg-no-repeat bg-center bg-cover relative h-[65vh] w-full"></div>
        </article>
      </section>
    </>
  );
}

export default Homepage;
